import { createSlice } from "@reduxjs/toolkit";

import { AuthAPI } from "../../services/auth";

const AuthSlice = createSlice({
  name: "auth",
  initialState: {
    adminRole: null,
    userRole: null,
    usersList: [],
    offset: 0,
    totalUsers: "",
    isAuth: "",
  },
  reducers: {
    setOffset: (state, action) => {
      state.offset = action.payload;
    },
    setIsAuthenticated: (state, action) => {
      const { token, adminRole } = action.payload;
      state.isAuth = token && adminRole ? true : false;
      state.adminRole = adminRole;
    },

    setUserRole: (state, action) => {
      state.userRole = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(AuthAPI.getUsersList.fulfilled, (state, action) => {
        const { users, total } = action.payload;

        state.usersList = users;
        state.totalUsers = total;
      })

      .addCase(AuthAPI.login.fulfilled, (state, action) => {
        const {
          token,
          role,
          user: { name },
        } = action.payload || {};

        if (token && role) {
          state.isAuth = true;
          state.adminRole = String(role);
          localStorage.setItem("token", token);
          localStorage.setItem("adminRole", role);
        }

        if (name) localStorage.setItem("user_name", name);
      })

      .addCase(AuthAPI.logout.fulfilled, (state) => {
        localStorage.clear();
        state.isAuth = false;
      });
  },
});

export const { setIsAuthenticated, setUserRole, setOffset } = AuthSlice.actions;

export default AuthSlice;
